module.exports = (__parcel__import__("aOPNJ")).then(() => parcelRequire('jppWD'));